import Vue from 'vue'
import VueRouter from 'vue-router'
import { eventHub } from "@/store/eventHub";
import i18next from 'i18next'
import authcheck from '@/helpers/authcheck'
import { routes } from '@/router/routes'
import store from '@/store'
import wsClient from '@/helpers/wsClient'

Vue.use(VueRouter)

import { RouterOptions } from 'vue-router'

const routerOptions: RouterOptions = {
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior () { return { x: 0, y: 0 } }
}

const router = new VueRouter(routerOptions)

router.beforeEach(async (to, _from, next) => {
  document.title = 'ModTools'

  let doNext = true
  let session = await store.getters['auth/session']
  // Authorization changes pushed to Vue by wss, so we make sure it's connected.
  if(!session || !session.authenticated || !session.wss) {
    await store.dispatch('auth/fetchSession')
    session = await store.getters['auth/session']
  } else {
    const wssAuth = await wsClient.wssAuth()
    if(wssAuth.data.status === 'authenticated') wsClient.initialize(session.user.id)
  }

  if(!session.wss && !session.authenticated) {
    doNext = false
  }

  if (doNext === true && typeof to === 'object' && to.params && typeof to.params.townName === 'string') {
    const townId = await store.getters['towns/townIdFromName'](to.params.townName)
    if(townId.length < 1) {
      doNext = false
      eventHub.$emit('triggerSnackbar', {
        color: 'warning',
        text: i18next.t('You are not a moderator of ') + to.params.townName + '. ' + i18next.t('Redirecting you to your dashboard in 4 seconds.'),
        timeout: 3000,
        undo: authcheck.loggedInRedirect,
        undoText: i18next.t('Go to dashboard')
      })
      setTimeout(() => { authcheck.loggedInRedirect() }, 3000)
    }
  }
  if(doNext)
    next()
})

const defaultTitle = 'ModTools | Freecycle'
router.afterEach((to) => {
  Vue.nextTick(() => {
    if (typeof to === 'object' && typeof to.meta === 'object')
      document.title = to.meta.title
    else document.title = defaultTitle
  })
})

export default router
